import React from 'react';
import NewImage from './Newimage';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact"



function grill() {
  return (
    <div className="grill" style={{marginTop : "50px"}}>
      <MDBContainer>
        <MDBRow>
          <MDBCol lg="3" md="3"></MDBCol>
          <MDBCol lg="6" md="6"><NewImage link="https://www.npmjs.com/package/basic-linechart" name="NPM lib basic-lineChart" date="2020-2021" addrImage="linechart.jpg"  /></MDBCol>
          <MDBCol lg="3" md="3"></MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol lg="3" md="3"><div className="l3"></div><div className="l4"></div></MDBCol>
          <MDBCol lg="6" md="6"><NewImage link="https://mitnoos.com/Spaceshooter/robot.html" name="Stars Wars Game (full js)" date="2020-2021" addrImage="spaceshooter.jpg" /></MDBCol>
          <MDBCol lg="3" md="3"></MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol lg="3" md="3"><div className="l3"></div><div className="l4"></div></MDBCol>
          <MDBCol lg="6" md="6"><NewImage link="http://www.lapetiteepope.fr/" name="La Petite Epopée" date="2019-2021"  addrImage="lpe.jpg"/></MDBCol>
          <MDBCol lg="3" md="3"><div className="l3"></div><div className="l4"></div></MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
}

export default grill;
